<template>
	<div class="status-bar">
		<div class="status-bar__item">
			<span class="status-bar__label">总权益</span>
			<span class="status-bar__value" :class="equityClass">
				<span v-if="equityClass" class="status-bar__trend">{{ equityClass === 'is-up' ? '▲' : '▼' }}</span>
				{{ fmtMoney(equity) }}
			</span>
		</div>
		<div class="status-bar__item">
			<span class="status-bar__label">可用余额</span>
			<span class="status-bar__value">{{ fmtMoney(balance) }}</span>
		</div>
		<div class="status-bar__item">
			<span class="status-bar__label">持仓数</span>
			<span class="status-bar__value">{{ positionCount }}</span>
		</div>
		<div class="status-bar__item">
			<span class="status-bar__label">借入</span>
			<span class="status-bar__value" :class="{ 'is-warn': debt > 0 }">{{ fmtMoney(debt) }}</span>
		</div>
		<div class="status-bar__item">
			<span class="status-bar__label">累计利息</span>
			<span class="status-bar__value is-warn">{{ fmtMoney(interestPaid) }}</span>
		</div>
	</div>
</template>

<script>
import { fmtMoney } from '@/util/fx/format'

export default {
	name: 'StatusBar',
	props: {
		equity: {
			type: Number,
			default: 0
		},
		balance: {
			type: Number,
			default: 0
		},
		positionCount: {
			type: Number,
			default: 0
		},
		debt: {
			type: Number,
			default: 0
		},
		interestPaid: {
			type: Number,
			default: 0
		},
		initialBalance: {
			type: Number,
			default: 0
		}
	},
	computed: {
		/**
		 * 权益颜色类：高于初始资金为红、低于为绿
		 */
		equityClass() {
			if (!this.initialBalance) {
				return ''
			}
			if (this.equity > this.initialBalance) {
				return 'is-up'
			}
			if (this.equity < this.initialBalance) {
				return 'is-down'
			}
			return ''
		}
	},
	methods: {
		fmtMoney
	}
}
</script>

<style scoped>
.status-bar {
	display: flex;
	flex-wrap: wrap;
	gap: 8px 26px;
}

.status-bar__item {
	display: flex;
	align-items: baseline;
	gap: 8px;
}

.status-bar__label {
	font-size: 12.5px;
	color: var(--fx-text-dim);
	letter-spacing: 0.06em;
}

.status-bar__value {
	font-size: 16px;
	font-weight: 700;
	font-family: var(--fx-mono);
	font-variant-numeric: tabular-nums;
	color: var(--fx-text);
}

.status-bar__trend {
	font-size: 13px;
	margin-right: 2px;
}

.status-bar__value.is-up {
	color: var(--fx-up);
}

.status-bar__value.is-down {
	color: var(--fx-down);
}

.status-bar__value.is-warn {
	color: var(--fx-warn);
}
</style>
